import { TaskService } from '@weave/schema-gen-ts/dist/schemas/task-center/v1/task_service.pb';
import { TaskService as TaskServiceV2 } from '@weave/schema-gen-ts/dist/schemas/task-center/v2/task_service.pb';
import { QueryKey } from 'react-query';
import { bindHTTP } from '@frontend/schema';

export const SchemaTaskCenter = bindHTTP(TaskService);
export const SchemaTaskCenterV2 = bindHTTP(TaskServiceV2);

export const serviceKey: QueryKey = ['task-center'];
